import { useTranslation } from 'react-i18next';
import IconButton, { Props as IconButtonProps } from '@wix/da-ds/pkg/Buttons/IconButton';
import React, { useCallback } from 'react';
import { BiData, TopNavClickBiEvent } from '@wix/da-bi/pkg/events';
import SearchIcon16 from '@wix/da-ds/pkg/Icons/16x16/Search';
import SearchModal from '../../../_partials/SearchModal';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';

export interface Props extends Omit<IconButtonProps, 'size' | 'icon'> {
  className?: string;
  isSearchModalShown?: boolean;
  openSearchModal: () => void;
  closeSearchModal: () => void;
}

const SearchIconButton: React.FC<Props> = ({
  className,
  isSearchModalShown,
  openSearchModal,
  closeSearchModal,
}) => {
  const { t } = useTranslation();
  const handleOpen = useCallback(() => {
    yieldToMain(() => {
      openSearchModal();
    });
  }, [openSearchModal]);
  const handleClose = useCallback(() => {
    yieldToMain(() => {
      closeSearchModal();
    });
  }, [closeSearchModal]);

  return (
    <>
      <IconButton
        className={className}
        size="medium"
        icon={SearchIcon16}
        biData={BiData<TopNavClickBiEvent>({
          evid: 700,
          link_name: 'search',
        })}
        onClick={handleOpen}
        aria-label={t('common.search')}
      />
      {isSearchModalShown && <SearchModal onClose={handleClose} />}
    </>
  );
};
SearchIconButton.displayName = 'SearchIconButton';

export default SearchIconButton;
